export const selectFriend = (selectedFriendId, friendType, friendInfo, gochiUserType) => {
  return {
    type : 'SELECT_FRIEND',
    selectedFriendId,
    friendType,
    friendInfo,
    gochiUserType 
  }
}; 
 